export const LOGIN_STEPS = {
  EMAIL: 1,
  PASSWORD: 2,
} as const;

export type LoginStep = (typeof LOGIN_STEPS)[keyof typeof LOGIN_STEPS];
